module.exports = __webpack_public_path__ + "static/img/wan-fo-shen-qi-ye.41e24ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/wan-fo-shen-qi-ye.jpg
// module id = zj1k
// module chunks = 1